import { z } from 'zod';
import { isPlainDate } from '../date/index.js';
/** E-mail sempre normalizado em minusculas: a unicidade no banco depende disso. */
export const emailSchema = z
    .string()
    .trim()
    .min(3)
    .max(254)
    .email('E-mail invalido.')
    .transform((value) => value.toLowerCase());
export const cuidSchema = z
    .string()
    .min(20)
    .max(40)
    .regex(/^[a-z0-9]+$/i, 'Identificador invalido.');
export const nameSchema = z.string().trim().min(2, 'Informe ao menos 2 caracteres.').max(120);
/** Centavos na borda da API: string decimal inteira, convertida para bigint. */
export const centsSchema = z
    .string()
    .regex(/^-?\d{1,15}$/, 'Valor monetario deve ser um inteiro em centavos, como texto.')
    .transform((value) => BigInt(value));
export const plainDateSchema = z
    .string()
    .refine(isPlainDate, 'Data invalida. Use o formato AAAA-MM-DD.');
export const paginationSchema = z.object({
    cursor: z.string().max(200).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
export const okSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=common.js.map